import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { AdModal } from './AdModal';

export const SupportButton: React.FC = () => {
  const [isAdModalOpen, setIsAdModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsAdModalOpen(true)}
        className="fixed bottom-6 right-6 p-3 bg-gradient-to-r from-pink-600 to-rose-600 hover:from-pink-700 hover:to-rose-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center z-40 group"
        title="Support the developer by viewing an ad"
      >
        <Heart className="w-6 h-6 fill-white" />
        <span className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Support Developer
        </span>
      </button>

      <AdModal
        isOpen={isAdModalOpen}
        onClose={() => setIsAdModalOpen(false)}
        onSuccess={() => {
          // Optional: add rewards or track support
        }}
      />
    </>
  );
};
